import { AmplifyClient } from "@momentum/auth/client";

export const amplifyClient = new AmplifyClient({
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
  cognitoDomain: import.meta.env.VITE_COGNITO_DOMAIN,
  cognitoRegion: import.meta.env.VITE_COGNITO_REGION,
  cognitoUserPoolId: import.meta.env.VITE_COGNITO_POOL_ID,
  cognitoScopes: ["email", "openid", "profile"],
  cognitoProviders: ["google", "apple"],
  signInRedirectUrl: import.meta.env.VITE_COGNITO_SIGN_IN_REDIRECT_URL,
  signOutRedirectUrl: import.meta.env.VITE_COGNITO_SIGN_OUT_REDIRECT_URL,
});
